import { produce } from 'immer';
import { entity } from 'simpler-state';

import entityReduxLogger from '../../debug/helpers/entity-redux-logger';
import { TopGainerAndLoserData } from '../../models/fundamental/types';

import { INITIAL_STATE } from './constants';
import { getInitialItems, setInitialItems, updateTopMovers } from './helpers';
import { TopMoversCacheData } from './types';
// TODO : This cache file will be simplified within ART-3785

const TopGainersCache = entity(INITIAL_STATE, entityReduxLogger('TopGainers', 'top-gainers'));

const self = TopGainersCache;

/**
 * Must be used only by the `getPriceForTopMovers` epic in `store/fundamental/epics.ts`
 */
export const setTopGainersInitialItems = setInitialItems(self);

/**
 * Must be used only by the `getPriceForTopMovers` helper in `store/fundamental/helpers.ts`
 */
export const updateTopGainers = (newData: TopGainerAndLoserData[]) => {
  updateTopMovers(self, newData);
};

/**
 * Must be used only by the `getPriceForTopMovers` helper in `store/fundamental/helpers.ts`
 */
export const setTopGainersTimeout = (isTimeout = true) => {
  self.set(produce<TopMoversCacheData>(state => {
    state.isTimeout = isTimeout;
    state.isReady = true;
  }));
};

// hiding direct setter by not including it in exports
export default {
  use: self.use,
  get: self.get,
  getInitialItems: getInitialItems(self),
};
